<div class="atlas-input" [class.has-suffix]="hasSuffix">
  <input class="atlas-input-element" [placeholder]="placeholder" type="text" (blur)="onBlur()" [formControl]="inputCtrl">
  <div class="atlas-input-suffix" (click)="clearInput()">
    <span *ngIf="!!inputCtrl.value && !inputCtrl.disabled" class="fa fa-times-circle icon-gray"></span>
    <span *ngIf="!!inputCtrl.disabled" class="fa fa-lock icon-gray"></span>
    <span *ngIf="errorState" class="fa fa-exclamation-circle icon-red"></span>
  </div>
</div>
